// extracted by mini-css-extract-plugin
module.exports = {"Landing":"Landing_Landing__3WE0r","Content":"Landing_Content__3olL1","PlayIcon":"Landing_PlayIcon__3jT8w"};